
import styled from 'styled-components';

const textComponents = {
  H1: styled.h1`
    font-size: ${props => props.theme.fontSizes.large};
    text-transform: uppercase;
    line-height: normal;
    font-weight:600;
    @media (min-width: ${props => (props.theme.breaks.mobile+1)}px) {
      font-size: ${props => props.theme.fontSizes.largeDesktop};
    }
    `,
    H2: styled.h2`
      font-size: ${props => props.theme.fontSizes.medium};
      text-transform: uppercase;
      font-weight:normal;
      margin:0 0 70px 0;
      line-height: normal;
      @media (min-width: ${props => (props.theme.breaks.mobile+1)}px) {
        font-size: ${props => props.theme.fontSizes.mediumDesktop};
        margin:0 0 150px 0;
      }
      `
};
export default textComponents;
